/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router";

function SEO({ description, title, image, themeColor, locale, noindex }) {
  const location = useLocation();
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            image
          }
        }
      }
    `
  );

  let languages = ["en", "de", "es"];
  const metaDescription = description || site.siteMetadata.description;
  const lang = locale;
  const path = location ? location.pathname.split("/" + lang + "/")[1] : "";

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | marbet`}
    >
      <script
        type="application/javascript"
        src="https://app.usercentrics.eu/latest/main.js"
        data-settings-id="0CfHUbbV7"
        id="0CfHUbbV7"
      ></script>
      {noindex && <meta name="robots" content="noindex" />}
      <meta name="theme-color" content={themeColor} />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={image} />
      <meta name="google-site-verification" content="" />
      <link
        rel="alternate"
        href={location ? location.origin + "/" + "de/" + path : ""}
        hrefLang="x-default"
        key={"x-default"}
      />
      <link
        rel="alternate"
        href={location ? location.origin + "/" + languages[0] + "/" + path : ""}
        hrefLang={languages[0]}
        key={languages[0]}
      />
      <link
        rel="alternate"
        href={location ? location.origin + "/" + languages[1] + "/" + path : ""}
        hrefLang={languages[1]}
        key={languages[1]}
      />
      <link
        rel="alternate"
        href={location ? location.origin + "/" + languages[2] + "/" + path : ""}
        hrefLang={languages[2]}
        key={languages[2]}
      />
    </Helmet>
  );
}

SEO.defaultProps = {
  description: ``,
  image: "",
  locale: "en",
  themeColor: "#FBFBFB",
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  location: PropTypes.any,
  themeColor: PropTypes.string,
  locale: PropTypes.string,
  noindex: PropTypes.bool,
};

export default SEO;
